import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['pagination', 'entries', 'spinner', 'sentinel'];

  initialize() {
    const options = { rootMargin: '300px' };
    this.intersectionObserver = new IntersectionObserver((entries) => this.processIntersectionEntries(entries), options);
    this.isLoading = false;
    if (this.hasSpinnerTarget) {
      $(this.spinnerTarget).hide();
    }
  }

  connect() {
    if (this.hasPaginationTarget) {
      this.intersectionObserver.observe(this.paginationTarget);
    }
    if (this.hasSentinelTarget) {
      this.intersectionObserver.observe(this.sentinelTarget);
    } else if (this.hasSpinnerTarget) {
      this.intersectionObserver.observe(this.spinnerTarget);
    }
  }

  disconnect() {
    if (this.hasPaginationTarget) {
      this.intersectionObserver.unobserve(this.paginationTarget);
    }
    if (this.hasSentinelTarget) {
      this.intersectionObserver.unobserve(this.sentinelTarget);
    } else if (this.hasSpinnerTarget) {
      this.intersectionObserver.unobserve(this.spinnerTarget);
    }
  }

  processIntersectionEntries(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadMore(entry.target);
      }
    });
  }

  loadMore() {
    if (!this.hasPaginationTarget) { return; }
    if (this.isLoading) { return; }
    const next_page = this.paginationTarget.querySelector("a[rel='next']");
    if (next_page == null) {
      this.intersectionObserver.unobserve(this.paginationTarget);
      if (this.hasSpinnerTarget) { this.intersectionObserver.unobserve(this.spinnerTarget); }
      return;
    }
    const url = next_page.href;
    this.isLoading = true;
    if (this.hasSpinnerTarget) { $(this.spinnerTarget).show(); }
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.intersectionObserver.unobserve(this.paginationTarget);
        this.paginationTarget.innerHTML = response.pagination;
        this.intersectionObserver.observe(this.paginationTarget);
        if (this.hasSpinnerTarget) { $(this.spinnerTarget).hide(); }
        this.isLoading = false;
      },
      error: () => { this.isLoading = false; if (this.hasSpinnerTarget) { $(this.spinnerTarget).hide(); } }
    });
  }
}
